var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors, cssVarsThemed } from '@creditornot/cb-ingredients';
import { createCssVarDefinitions, createCssVars } from '@creditornot/cb-utils';
var cssVars = createCssVars(['size']);
var colorCssVars = createCssVars(['color']);
var sizeConfig = {
    tiny: 14,
    small: 18,
    medium: 24,
    large: 44,
    extraLarge: 64,
    huge: 96,
};
var colorConfig = {
    blue: {
        light: colors.wolt100,
        dark: colors.wolt100,
    },
    lightGrey: {
        light: '#A6A6A8',
        dark: '#7A7A7A', // salt48 solid
    },
    grey: {
        light: '#707173',
        dark: '#B8B8B8', // salt72 solid
    },
    white: {
        light: colors.salt100,
        dark: colors.space100,
    },
    red: {
        light: colors.strawberry100,
        dark: colors.strawberry100,
    },
};
var mainRotation = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  100% {\n    transform: rotate(360deg);\n  }\n"], ["\n  100% {\n    transform: rotate(360deg);\n  }\n"])));
var circle1Rotation = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  0% {\n    transform: rotate(50deg);\n  }\n  100% {\n    transform: rotate(770deg);\n  }\n"], ["\n  0% {\n    transform: rotate(50deg);\n  }\n  100% {\n    transform: rotate(770deg);\n  }\n"])));
var circle2Rotation = keyframes(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(720deg);\n  }\n"], ["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(720deg);\n  }\n"])));
var Root = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  position: relative;\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n"], ["\n  ", "\n\n  ", "\n\n  position: relative;\n  width: ", ";\n  height: ", ";\n  display: inline-block;\n"])), function (_a) {
    var _b;
    var $color = _a.$color, $cssVarOverrides = _a.$cssVarOverrides;
    return cssVarsThemed({
        color: (_b = $cssVarOverrides === null || $cssVarOverrides === void 0 ? void 0 : $cssVarOverrides.color) !== null && _b !== void 0 ? _b : colorConfig[$color],
    });
}, function (_a) {
    var _b;
    var $cssVarOverrides = _a.$cssVarOverrides, $size = _a.$size;
    return createCssVarDefinitions({
        size: (_b = $cssVarOverrides === null || $cssVarOverrides === void 0 ? void 0 : $cssVarOverrides.size) !== null && _b !== void 0 ? _b : "".concat(sizeConfig[$size], "px"),
    });
}, cssVars.size, cssVars.size);
var AnimationContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  animation: ", " 2.5s infinite linear;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  animation: ", " 2.5s infinite linear;\n"])), mainRotation);
var Container1 = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  &,\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  circle {\n    stroke: ", ";\n    stroke-opacity: 0.2;\n  }\n"], ["\n  &,\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  circle {\n    stroke: ", ";\n    stroke-opacity: 0.2;\n  }\n"])), colorCssVars.color);
var Container2 = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  animation: ", " 2.2s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);\n\n  &,\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  circle {\n    stroke: ", ";\n    stroke-linecap: round;\n    stroke-dasharray: 50, 150;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n  }\n"], ["\n  animation: ", " 2.2s infinite cubic-bezier(0.45, 0.05, 0.55, 0.95);\n\n  &,\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  circle {\n    stroke: ", ";\n    stroke-linecap: round;\n    stroke-dasharray: 50, 150;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n  }\n"])), circle1Rotation, colorCssVars.color);
var Container3 = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  animation: ", " 2.2s infinite linear;\n\n  &,\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  circle {\n    stroke: ", ";\n    stroke-dasharray: 45, 150;\n    stroke-linecap: round;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n  }\n"], ["\n  animation: ", " 2.2s infinite linear;\n\n  &,\n  svg {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  circle {\n    stroke: ", ";\n    stroke-dasharray: 45, 150;\n    stroke-linecap: round;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n  }\n"])), circle2Rotation, colorCssVars.color);
var Spinner = React.forwardRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? 'blue' : _b, cssVarOverrides = _a.cssVarOverrides, size = _a.size, rest = __rest(_a, ["color", "cssVarOverrides", "size"]);
    return (React.createElement(Root, __assign({ "$color": color, "$cssVarOverrides": cssVarOverrides, "$size": size }, rest, { ref: ref }),
        React.createElement(AnimationContainer, null,
            React.createElement(Container1, null,
                React.createElement("svg", { viewBox: "0 0 50 50" },
                    React.createElement("circle", { cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }))),
            React.createElement(Container2, null,
                React.createElement("svg", { viewBox: "0 0 50 50" },
                    React.createElement("circle", { cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }))),
            React.createElement(Container3, null,
                React.createElement("svg", { viewBox: "0 0 50 50" },
                    React.createElement("circle", { cx: "25", cy: "25", fill: "none", r: "20", strokeWidth: "5" }))))));
});
Spinner.displayName = 'Spinner';
export default Spinner;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=Spinner.js.map